module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-keyboard",
    on: {
      "touchstart": _vm.keyPress
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "3"
    }
  }, [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "6"
    }
  }, [_vm._v("6")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "9"
    }
  }, [_vm._v("9")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item",
    attrs: {
      "data-value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "item delete",
    attrs: {
      "data-value": "del"
    }
  }, [_vm._v("删除")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afe7009","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/temp/index.vue
// module id = 366
// module chunks = 0